import { createFileRoute, Link, redirect } from "@tanstack/react-router"
import { z } from "zod/v4"

import { Logo } from "@/components/logo"
import { ConfirmAccountPage } from "@/pages/confirm-account/page"

const confirmAccountSchema = z.object({
  token: z.string().min(1, "Token é obrigatório"),
})

export const Route = createFileRoute("/confirm-account")({
  validateSearch: (search) => confirmAccountSchema.parse(search),
  beforeLoad: ({ search }) => {
    if (!search.token) {
      throw redirect({ to: "/" })
    }

    return null
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-6 p-6 md:p-10">
      <div className="flex w-full max-w-sm flex-col gap-6">
        <Link to="/" className="flex items-center self-center">
          <Logo size="lg" />
        </Link>
        <ConfirmAccountPage />
      </div>
    </div>
  )
}
